import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DaButtonModule } from '../da-button';
import { HubspotModule } from '../hubspot';
import { HubspotFormBoxComponent } from './hubspot-form-box.component';

@NgModule({
    declarations: [HubspotFormBoxComponent],
    imports: [CommonModule, HubspotModule, DaButtonModule],
    exports: [HubspotFormBoxComponent]
})
export class HubspotFormBoxModule {
    constructor() {}
}
